module.exports = __webpack_public_path__ + "img/blocked-user-inaktiv.2b7e2b0b.svg";